export default {
  items: [
    {
      title: true,
      name: 'Account',
      wrapper: {            // optional wrapper object
        element: '',        // required valid HTML5 element tag
        attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: ''             // optional class names space delimited list for title item ex: "text-center"
    },
    {
      name: 'Profile',
      url: '/account/profile',
      icon: 'fa fa-list fa-lg',
    },
    {
      name: 'Logout',
      url: '/logout',
      icon: 'fa fa-lock fa-lg',
    }
  ]
};



// WEBPACK FOOTER //
// ./src/views/Account/Sidebar/_nav.js